var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tr',[_c('th',[_vm._v(" "+_vm._s(_vm.displayName)+" ")]),_c('td',[_c('DatePicker',{model:{value:(_vm.mDate),callback:function ($$v) {_vm.mDate=$$v},expression:"mDate"}}),_c('TimePicker',{model:{value:(_vm.mTime),callback:function ($$v) {_vm.mTime=$$v},expression:"mTime"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }